export const SKILLS = [
  {
    key: 'acrobatics',
    label: 'Acrobatics',
    ability: 'dex',
    proficient: false,
    expertise: false,
    description: 'Performing acrobatic stunts, maintaining balance, and escaping bonds.'
  },
  {
    key: 'animalHandling',
    label: 'Animal Handling',
    ability: 'wis',
    proficient: false,
    expertise: false,
    description: 'Calming animals, intuiting their intentions, and training them.'
  },
  {
    key: 'arcana',
    label: 'Arcana',
    ability: 'int',
    proficient: false,
    expertise: false,
    description: 'Knowledge about magical lore, spells, and artifacts.'
  },
  {
    key: 'athletics',
    label: 'Athletics',
    ability: 'str',
    proficient: false,
    expertise: false,
    description: 'Physical feats of strength such as climbing, jumping, or swimming.'
  },
  {
    key: 'deception',
    label: 'Deception',
    ability: 'cha',
    proficient: false,
    expertise: false,
    description: 'Concealing the truth through lies, feints, and trickery.'
  },
  {
    key: 'history',
    label: 'History',
    ability: 'int',
    proficient: false,
    expertise: false,
    description: 'Recall of historical events, legendary people, and ancient civilizations.'
  },
  {
    key: 'insight',
    label: 'Insight',
    ability: 'wis',
    proficient: false,
    expertise: false,
    description: 'Reading body language, motives, and intentions.'
  },
  {
    key: 'intimidation',
    label: 'Intimidation',
    ability: 'cha',
    proficient: false,
    expertise: false,
    description: 'Influencing others through threats, hostile actions, and fear.'
  },
  {
    key: 'investigation',
    label: 'Investigation',
    ability: 'int',
    proficient: false,
    expertise: false,
    description: 'Searching for clues and making deductions.'
  },
  {
    key: 'medicine',
    label: 'Medicine',
    ability: 'wis',
    proficient: false,
    expertise: false,
    description: 'Stabilizing the dying, diagnosing illnesses, and treating wounds.'
  },
  {
    key: 'nature',
    label: 'Nature',
    ability: 'int',
    proficient: false,
    expertise: false,
    description: 'Knowledge of terrain, plants, animals, weather, and natural cycles.'
  },
  {
    key: 'perception',
    label: 'Perception',
    ability: 'wis',
    proficient: false,
    expertise: false,
    description: 'Noticing clues, spotting hidden objects, and detecting danger.'
  },
  {
    key: 'performance',
    label: 'Performance',
    ability: 'cha',
    proficient: false,
    expertise: false,
    description: 'Entertaining audiences through music, dance, or acting.'
  },
  {
    key: 'persuasion',
    label: 'Persuasion',
    ability: 'cha',
    proficient: false,
    expertise: false,
    description: 'Influencing others with tact, diplomacy, and social grace.'
  },
  {
    key: 'religion',
    label: 'Religion',
    ability: 'int',
    proficient: false,
    expertise: false,
    description: 'Knowledge of deities, rites, prayers, and religious hierarchies.'
  },
  {
    key: 'sleightOfHand',
    label: 'Sleight of Hand',
    ability: 'dex',
    proficient: false,
    expertise: false,
    description: 'Picking pockets, palming objects, and performing delicate tricks.'
  },
  {
    key: 'stealth',
    label: 'Stealth',
    ability: 'dex',
    proficient: false,
    expertise: false,
    description: 'Concealing yourself from enemies and moving silently.'
  },
  {
    key: 'survival',
    label: 'Survival',
    ability: 'wis',
    proficient: false,
    expertise: false,
    description: 'Tracking, hunting, and navigating the wilderness.'
  }
];

export default SKILLS;
